import { SettingsKey } from "models";
import { useAppSelector } from "utils/store";

const dflPhotoClass = "w-1/4 mr-[10%]";
const dflSvgClass = "bg-[var(--ion-color-light-shade)] rounded max-w-full h-auto";
const dflPhotoSkeletonClass = "h-[1.2rem] mb-1 bg-[var(--ion-color-light-shade)] rounded";
const dflBlockClass = "mt-2";
const dflItemClass = "flex flex-row items-center my-0.5 mx-1";
const dflItemLabelClass = "w-28 font-bold text-[var(--ion-color-dark)] m-0";
const dflItemSkeletonClass = "h-[1.4rem] w-1/2 bg-[var(--ion-color-light-shade)] rounded";
const dflInlinePhotoClass = "w-1/4 h-auto";

const Preview = () => {
  const options = useAppSelector((state) => state.templateBuilderSlice.defaultOptions);

  const showPhotoMetadata = options[SettingsKey.ReportShowDefectPhotoMeta]?.value ?? true;

  return (
    <>
      <div className="w-full pb-[5%] bg-[var(--surface-200)] rounded"></div>

      <div className="pt-2 border-b-2 border-[var(--ion-color-dark)] pb-2 w-full min-h-10">
        {options.reportShowDefectOrientation?.value === "standard" && (
          <div className="w-full mt-2 flex flex-row">
            <div className={dflPhotoClass}>
              {showPhotoMetadata && <div className={dflPhotoSkeletonClass}></div>}
              <svg xmlns="http://www.w3.org/2000/svg" height="300" width="200" className={dflSvgClass}></svg>
            </div>
            <div className={dflPhotoClass}>
              {showPhotoMetadata && <div className={dflPhotoSkeletonClass}></div>}
              <svg xmlns="http://www.w3.org/2000/svg" height="300" width="200" className={dflSvgClass}></svg>
            </div>
            <div className={dflPhotoClass}>
              {showPhotoMetadata && <div className={dflPhotoSkeletonClass}></div>}
              <svg xmlns="http://www.w3.org/2000/svg" height="300" width="200" className={dflSvgClass}></svg>
            </div>
          </div>
        )}

        <div className="flex flex-row">
          <div className={`${dflBlockClass} flex-1`}>
            {options.reportShowDefectNumber?.value && (
              <div className={dflItemClass}>
                <p className={dflItemLabelClass}>Number</p>
                <div className={dflItemSkeletonClass}></div>
              </div>
            )}

            {options.reportShowDefectArea?.value && (
              <div className={dflItemClass}>
                <p className={dflItemLabelClass}>Area</p>
                <div className={dflItemSkeletonClass}></div>
              </div>
            )}

            {options.reportShowDefectElement?.value && (
              <div className={dflItemClass}>
                <p className={dflItemLabelClass}>Element</p>
                <div className={dflItemSkeletonClass}></div>
              </div>
            )}

            {options.reportShowDefectIssue?.value && (
              <div className={dflItemClass}>
                <p className={dflItemLabelClass}>Issue</p>
                <div className={dflItemSkeletonClass}></div>
              </div>
            )}

            {options.reportShowDefectOrientation?.value === "inline" && (
              <div>
                {options.reportShowDefectStatus?.value && (
                  <div className={dflItemClass}>
                    <p className={dflItemLabelClass}>Status</p>
                    <div className={dflItemSkeletonClass}></div>
                  </div>
                )}

                {options.reportShowDefectPriority?.value && (
                  <div className={dflItemClass}>
                    <p className={dflItemLabelClass}>Priority</p>
                    <div className={dflItemSkeletonClass}></div>
                  </div>
                )}

                {options[SettingsKey.ReportShowDefectCreatedate]?.value && (
                  <div className={dflItemClass}>
                    <p className={dflItemLabelClass}>Created</p>
                    <div className={dflItemSkeletonClass}></div>
                  </div>
                )}

                {options.reportShowDefectDuedate?.value && (
                  <div className={dflItemClass}>
                    <p className={dflItemLabelClass}>Due Date</p>
                    <div className={dflItemSkeletonClass}></div>
                  </div>
                )}
              </div>
            )}
          </div>

          {options.reportShowDefectOrientation?.value !== "inline" && (
            <div className={`${dflBlockClass} flex-1`}>
              {options.reportShowDefectStatus?.value && (
                <div className={dflItemClass}>
                  <p className={dflItemLabelClass}>Status</p>
                  <div className={dflItemSkeletonClass}></div>
                </div>
              )}

              {options.reportShowDefectPriority?.value && (
                <div className={dflItemClass}>
                  <p className={dflItemLabelClass}>Priority</p>
                  <div className={dflItemSkeletonClass}></div>
                </div>
              )}

              {options[SettingsKey.ReportShowDefectCreatedate]?.value && (
                <div className={dflItemClass}>
                  <p className={dflItemLabelClass}>Created</p>
                  <div className={dflItemSkeletonClass}></div>
                </div>
              )}

              {options.reportShowDefectDuedate?.value && (
                <div className={dflItemClass}>
                  <p className={dflItemLabelClass}>Due Date</p>
                  <div className={dflItemSkeletonClass}></div>
                </div>
              )}
            </div>
          )}

          {options.reportShowDefectOrientation?.value === "inline" && (
            <div className={`${dflInlinePhotoClass} mr-1`}>
              {showPhotoMetadata && <div className={dflPhotoSkeletonClass}></div>}
              <svg xmlns="http://www.w3.org/2000/svg" height="300" width="200" className={dflSvgClass}></svg>
            </div>
          )}

          {options.reportShowDefectOrientation?.value === "inline" && (
            <div className={dflInlinePhotoClass}>
              {showPhotoMetadata && <div className={dflPhotoSkeletonClass}></div>}
              <svg xmlns="http://www.w3.org/2000/svg" height="300" width="200" className={dflSvgClass}></svg>
            </div>
          )}

          {options.reportShowDefectQrCode?.value && (
            <div className={`${dflInlinePhotoClass} max-w-[15%] p-2`}>
              <svg xmlns="http://www.w3.org/2000/svg" height="150" width="150" className={dflSvgClass}></svg>
              <div className={`${dflPhotoSkeletonClass} mt-1`}></div>
            </div>
          )}
        </div>

        <div className={`w-full ${dflBlockClass}`}>
          {options.reportShowDefectComments?.value && (
            <div>
              <div className={dflItemClass}>
                <p className={dflItemLabelClass}>Details</p>
                <div className={dflItemSkeletonClass} style={{ width: "calc(100% - 7rem)" }}></div>
              </div>
              <div className={dflItemClass}>
                <p className={dflItemLabelClass}>&nbsp;</p>
                <div className={dflItemSkeletonClass} style={{ width: "calc(100% - 7rem)" }}></div>
              </div>
            </div>
          )}

          {options.reportShowDefectAssignment?.value && (
            <div className="mt-2">
              <div className={dflItemClass}>
                <p className={dflItemLabelClass}>Assigned to</p>
                <div className={dflItemSkeletonClass} style={{ width: "calc(100% - 7rem)" }}></div>
              </div>
            </div>
          )}
        </div>

        {options.reportShowDefectOrientation?.value === "below" && (
          <div className={`mt-2 w-full flex flex-row`}>
            <div className={dflPhotoClass}>
              {showPhotoMetadata && <div className={dflPhotoSkeletonClass}></div>}
              <svg xmlns="http://www.w3.org/2000/svg" height="300" width="200" className={dflSvgClass}></svg>
            </div>

            <div className={dflPhotoClass}>
              {showPhotoMetadata && <div className={dflPhotoSkeletonClass}></div>}
              <svg xmlns="http://www.w3.org/2000/svg" height="300" width="200" className={dflSvgClass}></svg>
            </div>

            <div className={dflPhotoClass}>
              {showPhotoMetadata && <div className={dflPhotoSkeletonClass}></div>}
              <svg xmlns="http://www.w3.org/2000/svg" height="300" width="200" className={dflSvgClass}></svg>
            </div>
          </div>
        )}

        {options.reportShowDefectActivity?.value && (
          <div className="mt-3">
            <div className={`w-full ${dflBlockClass}`}>
              <div className={`${dflItemClass} w-full`}>
                <p className={dflItemLabelClass}>Recent Activity</p>
              </div>
              <div className={`${dflItemClass} w-full`}>
                <div className={dflItemSkeletonClass}></div>
              </div>
              <div className={`${dflItemClass} w-full`}>
                <div className={dflItemSkeletonClass}></div>
              </div>
              <div className={`${dflItemClass} w-full`}>
                <div className={dflItemSkeletonClass}></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Preview;
